export default __webpack_public_path__ + "static/media/gallery_00.12f12d85.jpg";